/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_CardInputs */

const en_guide_json_rest_api_card = /** @type {(inputs: Guide_Json_Rest_Api_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master JSON in REST APIs: request/response formats, headers, status codes, and best practices.`)
};

const ko_guide_json_rest_api_card = /** @type {(inputs: Guide_Json_Rest_Api_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST API에서 JSON 마스터하기: 요청/응답 포맷, 헤더, 상태 코드, 모범 사례.`)
};

const ja_guide_json_rest_api_card = /** @type {(inputs: Guide_Json_Rest_Api_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST APIでのJSON活用をマスター：リクエスト/レスポンス形式、ヘッダー、ステータスコード、ベストプラクティス。`)
};

/**
* | output |
* | --- |
* | "Master JSON in REST APIs: request/response formats, headers, status codes, and best practices." |
*
* @param {Guide_Json_Rest_Api_CardInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_card = /** @type {((inputs?: Guide_Json_Rest_Api_CardInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_CardInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_card(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_card(inputs)
	return ja_guide_json_rest_api_card(inputs)
});